import { create } from 'zustand'
import { batchedUpdates } from './placeholder/batchedUpdates'
import { PackageType } from '@ca/common/types'
import { OrderFrame } from '@order/orderTypes'

export type MeasurementType = 'pd' | 'sh'

type PlaceholderState = {
  type: MeasurementType | null
  pckg?: PackageType
  frame: OrderFrame | null | undefined
  isOpen: boolean
  location?: string
  pathname?: string
  open: (type: MeasurementType, location?: string) => void
  setFrame: (frame: OrderFrame | null | undefined) => void
  setType: (type: MeasurementType) => void
  setPckg: (pckg: PackageType) => void
  setContext: ({
    location,
    pathname,
  }: {
    location?: string
    pathname?: string
  }) => void
  close: () => void
}

const useSdkModuleStorage = create<PlaceholderState>((set) => ({
  type: null,
  isOpen: false,
  frame: null,
  defaultValues: null,
  location: undefined,
  pathname: undefined,
  open: (type, location) => set(() => ({ type, isOpen: true, location })),
  setFrame: (frame) => set({ frame }),
  setType: (type) => set({ type }),
  setPckg: (pckg) => set({ pckg }),
  setContext: ({ location, pathname }) => set({ location, pathname }),
  close: () =>
    set(() => ({
      type: null,
      frame: null,
      isOpen: false,
      location: undefined,
      pathname: undefined,
    })),
}))

export const openPlaceholderUi = (type: MeasurementType, location?: string) => {
  batchedUpdates(() => {
    useSdkModuleStorage.getState().open(type, location)
  })
}

export const closePlaceholderUi = () => {
  batchedUpdates(() => {
    useSdkModuleStorage.getState().close()
  })
}

export default useSdkModuleStorage
